const firebaseConfig = {
	apiKey: 'AIzaSyDhtu0lYOJvZGEeczJYizhooNRh416yu_M',
	authDomain: 'bd-shop-3f040.firebaseapp.com',
	projectId: 'bd-shop-3f040',
	storageBucket: 'bd-shop-3f040.appspot.com',
	messagingSenderId: '827336294312',
	appId: '1:827336294312:web:e414a7477a530cdd1be79d'
};

export default firebaseConfig;
